import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  href?: string;
  className?: string;
  showPrice?: boolean;
}
export function CTAButton({
  text = 'SÍ, QUIERO EL SISTEMA COMPLETO →',
  href = '#compra',
  className = '',
  showPrice = false
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center ${className}`} data-id="element-63">
      {showPrice && <span className="text-amber-400 font-bold text-xl mb-2 drop-shadow-md" data-id="element-64">
          $19.990 ARS
        </span>}
      <a href={href} className="group relative inline-flex items-center justify-center px-8 py-4 font-bold text-white transition-all duration-200 bg-gradient-to-r from-amber-600 to-red-600 rounded-full hover:from-amber-500 hover:to-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-600 focus:ring-offset-zinc-900 shadow-[0_0_20px_rgba(245,158,11,0.4)] hover:shadow-[0_0_30px_rgba(245,158,11,0.6)] hover:-translate-y-1 w-full sm:w-auto text-center" data-id="element-65">
        <span className="text-lg md:text-xl tracking-wide" data-id="element-66">{text}</span>
      </a>
      <p className="mt-3 text-xs text-zinc-500 flex items-center gap-1" data-id="element-67">
        <span className="inline-block w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-68"></span>
        Acceso inmediato • Pago seguro
      </p>
    </div>;
}